"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditorTreeViewModule = /** @class */ (function () {
    function EditorTreeViewModule() {
    }
    return EditorTreeViewModule;
}());
exports.EditorTreeViewModule = EditorTreeViewModule;
